import { useCallback, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { actions } from "reducers/rainModal";
import { regionSelector } from "reducers/regions";
import {
  RainCreationRequestType,
  RainValidationRequestType,
} from "sagas/types/rainModal";
import { AppDispatch, RootState } from "store";
import { RainInputs } from "./RainInputs";
import { RainInputsContainerPropsType } from "./types";

const RainInputsContainer = (
  props: RainInputsContainerPropsType & ConnectorProps
): JSX.Element => {
  const { validateRainCreation, validateRainUpdate, form, actualRegion, type } =
    props;
  const lastEndTime = useRef("");
  const lastInitiaTime = useRef("");
  const lastDate = useRef("");

  const handleBlur = useCallback(() => {
    const rainTime = form?.getState().values.rainTime;
    const rainDate = form?.getState().values.rainDate;

    const hasEnoughValues = rainDate && (rainTime?.end || rainTime?.initial);
    const anyValueChanged =
      lastInitiaTime.current !== rainTime?.initial ||
      lastEndTime.current !== rainTime?.end ||
      lastDate.current !== rainDate;

    if (anyValueChanged && hasEnoughValues) {
      const requestParams: RainCreationRequestType = {
        date: rainDate,
        finishAt: rainTime?.end || "",
        regionId: actualRegion || "",
        startAt: rainTime?.initial || "",
      };

      if (type === "update") {
        validateRainUpdate({ ...requestParams, rainId: props.rainId });
      } else {
        validateRainCreation(requestParams);
      }
    }
    lastInitiaTime.current = rainTime?.initial || "";
    lastEndTime.current = rainTime?.end || "";
    lastDate.current = rainDate || "";
  }, [
    actualRegion,
    form,
    props.rainId,
    type,
    validateRainCreation,
    validateRainUpdate,
  ]);

  return <RainInputs {...props} onBlur={handleBlur} />;
};

const mapStateToProps = (state: RootState) => ({
  actualRegion: regionSelector(state).actualRegion?.id,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  validateRainCreation: (params: RainValidationRequestType) => {
    dispatch(actions.validateRainTimeCreationFetch(params));
  },
  validateRainUpdate: (params: RainValidationRequestType) => {
    dispatch(actions.validateRainTimeUpdateFetch(params));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(RainInputsContainer);
